export default __webpack_public_path__ + "static/media/noSearchItem.f7ad09a3.png";